

/*
	Source: htdocs/wim/js/core/src/VideoPlayer.js
*/
(function($, wimbledonCore) {
/**
	 * VideoPlayer
	 */
	function VideoPlayer() {
		var logger = new eventsCore.util.Logger('VideoPlayer');

		var event_id = 'wim_2017';
		var VP = this;
		var players = {};

		var onRelatedEvent;

		// window sizes used by ECP
		var sizes = {
			'global': 0,
			'tablet': 1,
			'desktop': 2
		};

		var init = function(id) {
			logger.info('initPlayer - id:%o', id);

			if (!players[id] && !Environment.isFacebook_ios) {
				players[id] = eventsPlayer.init(
					'/ecp/playerConfig.json',
					$('#wrapper_' + id)
				);

				logger.info('initPlayer - player:%o id:%o', players[id], players[id].id());

				players[id].on('ReadyEvent', onReadyEvent);
				players[id].on('StartEvent', onStartEvent);
				players[id].on('CompleteEvent', onCompleteEvent);
				players[id].on('PlayEvent', onPlayEvent);
				players[id].on('MeasureEvent', onMeasureEvent);
				players[id].on('PanelEvent', onPanelEvent);
				players[id].on('ControlsEvent', onControlsEvent);
				players[id].on('ClickEvent', onClickEvent);
				players[id].on('VideoModeEvent', onVideoModeEvent);
				players[id].on('FullscreenEvent', onFullscreenEvent);
				players[id].on('ErrorEvent', onErrorEvent);   
			}

			return players[id];
		};

		var loadStream = function(id, force) {
			var playObj = {};
			var model = activeVideo;
			var error = false;

			//stream data
			playObj.title = model.get('title');
			playObj.techOrder = null;
			playObj.streamType = model.get('streamType') || 'unknown';
			playObj.typeFixed = force;
			playObj.controls = false;
			playObj.poster = model.get('poster');
			playObj.cdn = model.get('cdn');
			//playObj.playerTech = 'native';

			playObj.windowSize = sizes[windowSize];

			if (model.get('hlsUrl')) {
				playObj.url = model.get('hlsUrl');
				playObj.mimeType = model.get('hlsMimeType');
			} 
			else if (model.get('progUrl')) {
				playObj.url = model.get('progUrl');
				playObj.mimeType = model.get('progMimeType');
			} 
			else {
				logger.error('loadStream - neither hls or prog video type found');
				error = true;
			}

			// values for webvtt tracks
			if (model.get('tracks')) {
				playObj.tracks = model.get('tracks');
			}

			if (model.get('ads')) {
				playObj.ads = model.get('ads');
			}

			// legacy page level data
			playObj.info = {
				'title': model.get('title'),
				'type': model.get('streamType') || 'unknown',
				'id': model.get('id'),
				'link': model.get('pageLink')
			};

			if (model.get('panelButton')) {
				playObj.config = {
					ui: {
						toolbar: {
							buttons: {
								panel: model.get('panelButton')
							}
						}
					}
				};
			}


			logger.info('loadStream - id:%o playObj:%o error:%o', id, playObj, error);

			if (!error) {
				players[id].load(playObj);
			}
		};

		/**
		 * start loading of video
		 * @param id - id of the player, as specified in html
		 * @param options - options to be passed to video player, consisting of:
		 *        forceType - allow forcing of video type to test controls live controls with a vod test stream
		 *        floated - true indicates video started in floated panel directly
		 *        metrics_prefix - value to use, if not Metrics.page_section when recording metrics for this player
		 */
		var setupVideo = function(_video, options) {
			var _default_options = {
				forceType: undefined,
				floated: undefined,
				videoData: undefined
			};
			options = _.extend({}, _default_options, options);

			activeVideo = _video;

			var id = activeVideo.get('id');
			var url;
			var mime;

			//logger.info('setupVideo - id:%o active:%o', id, activeVideo.id);

			/**
			 * may not need this for wim17, was put in place at masters because of issue with Firefox ESR and audio encodes at lower bitrates
			 *  - verify with Eythan that profiles for wim will use consistent audio codec which works for Firefox esr before removing
			 */
			 /*
			if ((activeVideo.streamType !== 'live' && activeVideo.streamType !== 'dvr') && Environment.getBrowser() === 'firefox' && !Environment.isMobileDevice()) {
				// append string to wwwhlshigh feed URL
				activeVideo.hlsUrl += (activeVideo.hlsUrl.indexOf('?') > -1) ? '&' : '?';
				activeVideo.hlsUrl += 'b=600-1700';
			}
			*/

			// if player in this container does not exist, create it
			if (!players[id]) {
				init(id);
			}

			logger.info('setupVideo - video:%o hls:%o prog:%o fb:%o', activeVideo, activeVideo.get("hlsUrl"), activeVideo.get("progUrl"), Environment.isFacebook_ios);

			// switch to use native ecp option
			if (!Environment.isFacebook_ios) {
				loadStream(id, options.forceType);
				$('.ecp-player').has('div[id="wrapper_' + id + '"]').show();
			} 
			else {
				//loadStream(id, options.forceType);
				//$('.ecp-player').has('div[id="wrapper_' + id + '"]').show();
				//return;

				if (activeVideo.get('hlsUrl')) {
					url = activeVideo.get('hlsUrl');
					mime = activeVideo.get('hlsMimeType');
				}
				else if (activeVideo.get('progUrl')) {
					url = activeVideo.get('progUrl');
					mime = activeVideo.get('progMimeType');
				}

				logger.info('loadVideo - facebook - url:%o mime:%o', url, mime);

				var tag = '<video id="fbVideo" width="100%" height="100%" controls autoplay preload="auto">' +
						  '  <source src="' + url + '" type="' + mime + '"></source>' +
						  '</video>';

				if ($('.ecp-player').has('div[id="wrapper_' + id + '"]').length > 0) {
					$('.ecp-player').has('div[id="wrapper_' + id + '"]').after(tag);
					// $('.ecp-player').has('div[id="wrapper_' + id + '"]').show();

					var video = $('#fbVideo')[0];

					setTimeout(function() {
						video.load();
						video.play();
					}, 500);
				}
				else {
					logger.error('loadVideo - no wrapper for given id:%o', id);
				}
			}
		};

		var load = function(id, options) {
			var videoData = options.videoData;
			var videoObj;
			logger.info('load - videodata:%o options:%o', videoData, options);

			if (videoData === undefined) {
				// fetch request
				var url = window.relatedContentVideoPath.replace('[videoid]', id);

				$.ajax({
			  		dataType: "json",
			  		url: url,
				  	success: function(data) {
				  		logger.info('load - success - data:%o', data);
						_.each(data.extradata, function(val, key, list) {
							data[key] = val;
						});

						if (data && data.cmsId){
							// create video object from data returned by related content
							videoObj = getVideoFromRelated(data)
							
							setupVideo(videoObj, options);
						}
						else {
							var data = {
								error: true
							}
							if (onRelatedEvent !== null && $.isFunction(onRelatedEvent)){
				                try{ 
				                    onRelatedEvent.call(this, data);
				                }
				                catch(e){
				                    
				                }
				            }
						}
					},
					error: function(XMLHttpRequest, textStatus, errorThrown) {
						//logger.warn('load - error getting video data: %o', errorThrown); 
						var data = {
							error: true
						}
						if (onRelatedEvent !== null && $.isFunction(onRelatedEvent)){
			                try{ 
			                    onRelatedEvent.call(this, data);
			                }
			                catch(e){
			                    
			                }
			            }
					}
				});
			} 
			else {
				// create video object from data passed to load call
				videoObj = getVideoFromData(videoData)
				setupVideo(videoObj, options);
			}
		};

		/**
		 * handle loading of live stream which has different json data params than vod
		 */
		var loadLive = function(options) {

			// TODO: use environment to set platform if not vod

			var liveVideo = getVideoFromOptions(options);

			logger.info('loadLive - liveVideo:%o options:%o', liveVideo, options);
			setupVideo(liveVideo, options);
		};

		/**
		 * create video object from related content format
		 */
		var getVideoFromRelated = function(data) {
			var adTag = [];
			var hls = '';
			var prog = '';

			if (data.preroll && data.preroll != 'false') {
				adTag.push({"type": "vast", "position": "preroll", "tag": data.preroll});
			}
			else {
				//force ad
				//adTag.push({"type": "vast", "position": "preroll", "tag": "http://local.wimbledon.com/en_GB/xml/man/adtag/adtag.xml"});
			}

			if (data.extradata.m3u8){
				if (data.extradata.m3u8.indexOf('.mp4') == (data.extradata.m3u8.length - 4)){
					prog = data.extradata.m3u8;
				}
				else {
					hls = data.extradata.m3u8;
				}
			}
			else if (data.extradata.prog) {
				prog = data.extradata.m3u8;
			}

			return new Video({
				id: data.cmsId,
				title: data.title,
				streamType: 'vod', 
				contentType: data.contentType,
				poster: data.thumb,
				dashUrl: '',
				hlsUrl: hls,
				progUrl: prog,
				ads: adTag,
				pageLink: data.extradata.share,
				replay_channel: '',
				track: '',
				cdn: '',
				panelButton: ''
			});
		};

		/**
		 * create video object from old style data object
		 */
		var getVideoFromOptions = function(options) {
			var platform = 'desktop';

			if (Environment.isMobileDevice()) {
				platform = 'mobileweb';
			}

			var stream = options.videoData.media[platform][0].url;
			var cdn = options.videoData.media[platform][0].cdn;

			logger.info('getVideoFromOptions - platform:%o stream:%o', platform, stream);

			// use the alternate vod provided in data
			if (options.streamType == 'vod') {
				stream = options.videoData.media['vod'].url;
				cdn = options.videoData.media['vod'].cdn;
			}

			return new Video({
				id: options.videoId,
				title: options.videoTitle,
				streamType: options.streamType, 
				contentType: options.contentType,  // used for vod as content catgeory
				poster: options.videoData.images.slate,
				dashUrl: '',
				hlsUrl: stream,
				progUrl: '',
				pageLink: options.link,
				replay_channel: '',
				track: '',
				cdn: cdn,
				panelButton: ''
			});
		};

		/**
		 * create video object from videoData style object
		 */
		var getVideoFromData = function(videoData) {
			var adTag = [];
			if (videoData.preroll && videoData.preroll != "false") {
				adTag.push({"type": "vast", "position": "preroll", "tag": videoData.preroll});
			}

			return new Video({
				id: videoData.id,
				title: videoData.title,
				streamType: videoData.type, 
				contentType: videoData.contentType,
				poster: videoData.pictureM,
				dashUrl: '',
				hlsUrl: videoData.wwwhlshigh,
				progUrl: videoData.pdl,
				ads: adTag,
				pageLink: videoData.link,
				replay_channel: '',
				track: '',
				cdn: '',
				panelButton: ''
			});
		};

		var dispose = function(id) {
			if (eventsPlayer && players[id]) {
				players[id].stop();
				eventsPlayer.destroy('#wrapper_' + id);
				delete players[id];
			}
		};

		var onReadyEvent = function(data) {
			logger.info('onReadyEvent - id:%o', data.id);
		};

		var onPlayEvent = function() {
			logger.info('onPlayEvent');
		};

		var onStartEvent = function(data) {
			logger.info('onStartEvent - data:%o', data);
		};

		var onCompleteEvent = function(data) {
			logger.info('onCompleteEvent - data:%o', data);
		};

		var onMeasureEvent = function(data) {
			logger.info('onMeasureEvent - data:%o type:%o', data, data.type);
		};

		var onControlsEvent = function(data) {
			logger.info('onControlsEvent - vis:%o', data.visible);
		};

		var onPanelEvent = function(data) {
			logger.info('onPanelEvent - open:%o', data.open);
		};

		var onClickEvent = function(data) {
			logger.info('onClickEvent - type:%o', data.type);
		};

		var onVideoModeEvent = function(data) {
			logger.info('onVideoModeEvent - data:%o mode:%o', data, data.mode);
		};

		var onFullscreenEvent = function(data) {
			logger.info('onFullscreenEvent - data:%o', data);
		};

		var onErrorEvent = function(data) {
			logger.info('onErrorEvent - data:%o', data);
		};

		var on = function(name, handler) {
            switch (name) {
                case 'CompleteEvent':
                    onCompleteEvent = handler;
                    break;
                case 'StartEvent':
                    onStartEvent = handler;
                    break;
                case 'PlayEvent':
                    onPlayEvent = handler;
                    break;
                case 'MeasureEvent':
                    onMeasureEvent = handler;
                    break;
                case 'RelatedEvent':
                    onRelatedEvent = handler;
                    break;
                default:
                    break;
            }
        };

		return {
			init: init,
			on: on,
			load: load,
			loadLive: loadLive,
			dispose: dispose
		};
	}

	/**
	 * Video object
	 */
	function Video(attributes, options) {
		var defaults = {
			id: '',
			title: '',
			streamType: '',
			contentType: '',
			poster: '',
			tracks: '',
			ads: '',
			dashUrl: '',
			hlsUrl: '',
			progUrl: '',
			hlsMimeType: 'application/x-mpegURL',
			progMimeType: 'video/mp4',
			ads: [],
			pageLink: '',
			replay_channel: '',
			track: '',
			cdn: 'unknown',
			panelButton: ''
		};

		/**
		 * Simplified port of Backbone Model.set method
		 */
		this.set = function(key, val, options) {
			if (key == null) return this;

			var attrs;
			if (typeof key === 'object') {
				attrs = key;
				options = val;
			} else {
				(attrs = {})[key] = val;
			}

			options || (options = {});

			var current = this.attributes;

			for (var attr in attrs) {
				val = attrs[attr];
				current[attr] = val;
			}

			return this;
		};

		this.get = function(attr) {
			return this.attributes[attr];
		};

		/**
		 * Again, simplified port of Backbone.Model initialization code
		 */
		var attrs = attributes || {};
		options || (options = {});
		this.attributes = {};
		attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
		this.set(attrs, options);
	}

	wimbledonCore.videoPlayer = new VideoPlayer();
}(jQuery, window.wimbledonCore));
